import { createApp, defineAsyncComponent } from 'vue';

import Helpers from '@/utils/helper';
import iziToast from '../plugins/izitoast';
import emitter from '../plugins/emitter';

const app = createApp({
    data() {
        return {
            lang: window.lang || 'en',
        }
    },
    
    components: {
        VueProfilePicture: defineAsyncComponent(() => import('./ProfilePicture')),
        VuePersonalInfoForm: defineAsyncComponent(() => import('./PersonalInfoForm')),
        VueEducationalQualificationForm: defineAsyncComponent(() => import('./EducationalQualificationForm')),
        VuePreviousExperienceForm: defineAsyncComponent(() => import('./PreviousExperienceForm')),
        VueTrainingForm: defineAsyncComponent(() => import('./TrainingForm')),
        VueTrainingDelete: defineAsyncComponent(() => import('./TrainingDelete')),
        VueTrainingEditForm: defineAsyncComponent(() => import('./TrainingEditForm')),
        VueAchievementForm: defineAsyncComponent(() => import('./AchievementForm')),
        VueAchievementEditForm: defineAsyncComponent(() => import('./AchievementEditForm')),
        VueAchievementDelete: defineAsyncComponent(() => import('./AchievementDelete')),
        VueAchievements: defineAsyncComponent(() => import('./Achievements')),
        VueContents: defineAsyncComponent(() => import('./Contents')),
        VueCoverPicture: defineAsyncComponent(() => import('./CoverPicture')),
        VueSkills: defineAsyncComponent(() => import('./Skills')),
        VueLanguages: defineAsyncComponent(() => import('./Languages')),
        VueProfileLink: defineAsyncComponent(() => import('./ProfileLink')),
    },
});

app.use(iziToast);
app.use(emitter);
app.mixin(Helpers);

app.mount('#vue__teacher__profile');

